// extracted by mini-css-extract-plugin
export default {"sectionSix":"SectionSix_sectionSix__zOSL4","inputGroup":"SectionSix_inputGroup__F3gBS"};